export default __webpack_public_path__ + "static/fuel-special-offer-card-fc0e7dca71e512660f532421351e7a32.png";